module.exports = __webpack_public_path__ + "recruit-new-members-white.svg?35d03278db87d636d9030afa78015f45";